import { Badge, badgeColorSchema } from '@design/components/badge/Badge';
import clsx from 'clsx';
import { z } from 'zod';

import styles from './GradientCard.module.scss';

export const GRADIENT_CARD_ACCENTS = ['success', 'error', 'warning'] as const;
export const gradientCardAccentSchema = z.enum(GRADIENT_CARD_ACCENTS);

export const gradientCardPropsSchema = z
  .object({
    eyebrow: z.string().min(1),
    body: z.string().min(1),
    footnote: z.string().min(1),
    tagLabel: z.string().min(1),
    tagColor: badgeColorSchema,
    accent: gradientCardAccentSchema.optional(),
  })
  .strict();

export type GradientCardAccent = z.infer<typeof gradientCardAccentSchema>;
export type GradientCardDataProps = z.infer<typeof gradientCardPropsSchema>;

export interface GradientCardProps extends GradientCardDataProps {
  /** Extra class forwarded to the root element. */
  className?: string;
}

export const GradientCard = ({
  eyebrow,
  body,
  footnote,
  tagLabel,
  tagColor,
  accent = 'success',
  className,
}: GradientCardProps) => {
  return (
    <div
      className={clsx(styles.root, className, {
        [styles.accentSuccess]: accent === 'success',
        [styles.accentError]: accent === 'error',
        [styles.accentWarning]: accent === 'warning',
      })}
    >
      <div className={styles.bodySection}>
        <div className={styles.metaRow}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <Badge
            color={tagColor}
            size="xsmall"
            badgeStyle="outline"
            label={tagLabel}
          />
        </div>
        <p className={styles.body}>{body}</p>
      </div>
      <p className={styles.footnote}>{footnote}</p>
    </div>
  );
};
